<div class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-dark d-flex justify-content-between">
    <div class="navbar-container">
        <ul class="nav navbar-nav">
            <li class="nav-item">
                <a class="navbar-brand" href="javascript:void(0)">
                    <img class="brand-logo logo" src="/assets/images/logo-light.svg">
                </a>
            </li>
        </ul>
    </div>
    <div class="navbar-container">
        <ul class="nav navbar-nav float-right">
            <li class="dropdown dropdown-notification nav-item">
                <!-- Notifications -->
                <a class="nav-link nav-link-label" href="javascript:void(0)" data-toggle="dropdown"
                    (click)="notificationsViewed()">
                    <i class="ficon feather icon-bell"></i>
                    <span class="badge badge-pill badge-danger badge-up" *ngIf="count">{{count}}</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right p-0">
                    <li class="dropdown-menu-header">
                        <h6 class="dropdown-header m-0 p-1">
                            <span class="grey darken-2">Notifications</span>
                        </h6>
                    </li>
                    <li class="scrollable-container media-list dropdown-notifications">
                        <a href="javascript:void(0)" *ngFor="let notification of notifications; let i = index"
                            [routerLink]="[notification.navigation]" (click)="navigateTo(notification, i)">
                            <div class="media"
                                [ngStyle]="{'background': !notification.isClicked ? 'rgb(227 227 227)' : 'unset'}">
                                <div class="media-left align-self-center">
                                    <i class="feather icon-plus-square icon-bg-circle bg-cyan"></i>
                                </div>
                                <div class="media-body">
                                    <h6 class="media-heading" *ngIf="notification.course">{{notification.course.name}}
                                    </h6>
                                    <p class="notification-text font-small-3 text-muted">{{notification.text}}</p>
                                    <small>
                                        <time class="media-meta text-muted">{{notification.createdAt}}</time>
                                    </small>
                                </div>
                            </div>
                        </a>
                        <div class="placeholder p-3" *ngIf="!notifications.length ">
                            <img src="assets/images/no-users.png" alt="" style="height: 11rem;">
                            <p>No Notification</p>
                        </div>

                        <!-- <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left align-self-center"><i
                                        class="feather icon-download-cloud icon-bg-circle bg-red bg-darken-1"></i></div>
                                <div class="media-body">
                                    <h6 class="media-heading red darken-1">99% Server load</h6>
                                    <p class="notification-text font-small-3 text-muted">Aliquam tincidunt mauris eu
                                        risus.</p>
                                    <small>
                                        <time class="media-meta text-muted" datetime="2015-06-11T18:29:20+08:00">Five
                                            hour
                                            ago</time></small>
                                </div>
                            </div>
                        </a>
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left align-self-center"><i
                                        class="feather icon-alert-triangle icon-bg-circle bg-yellow bg-darken-3"></i>
                                </div>
                                <div class="media-body">
                                    <h6 class="media-heading yellow darken-3">Warning notifixation</h6>
                                    <p class="notification-text font-small-3 text-muted">Vestibulum auctor dapibus
                                        neque.</p>
                                    <small>
                                        <time class="media-meta text-muted"
                                            datetime="2015-06-11T18:29:20+08:00">Today</time></small>
                                </div>
                            </div>
                        </a>
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left align-self-center"><i
                                        class="feather icon-check-circle icon-bg-circle bg-cyan"></i></div>
                                <div class="media-body">
                                    <h6 class="media-heading">Complete the task</h6><small>
                                        <time class="media-meta text-muted" datetime="2015-06-11T18:29:20+08:00">Last
                                            week</time></small>
                                </div>
                            </div>
                        </a>
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left align-self-center"><i
                                        class="feather icon-file icon-bg-circle bg-teal"></i>
                                </div>
                                <div class="media-body">
                                    <h6 class="media-heading">Generate monthly report</h6><small>
                                        <time class="media-meta text-muted" datetime="2015-06-11T18:29:20+08:00">Last
                                            month</time></small>
                                </div>
                            </div>
                        </a> -->
                    </li>
                    <!-- <li class="dropdown-menu-footer bg-light">
                        <a class="dropdown-item text-muted text-center p-1" href="javascript:void(0)">Read all notifications</a>
                    </li> -->
                </ul>
            </li>
            <!-- User Data -->
            <li class="dropdown dropdown-user nav-item">
                <a class="dropdown-toggle nav-link dropdown-user-link" href="#" data-toggle="dropdown">
                    <div class="avatar avatar-online">
                        <img src="{{imgUrl + currentUser.profileImg}}" alt="avatar"
                            onerror="this.src='assets/images/default-user.png'">
                    </div>
                    <span class="user-name">{{currentUser.firstName + ' ' + currentUser.lastName}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    <a class="dropdown-item" href="javascript:void(0)"
                        [routerLink]="['/users', currentUser.id, 'profile']">
                        <i class="feather icon-user"></i> View Profile
                    </a>
                    <a class="dropdown-item" href="javascript:void(0)" [routerLink]="['/users/account/settings']">
                        <i class="feather icon-mail"></i> Settings
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="logOut()">
                        <i class="feather icon-power"></i> Logout
                    </a>
                </div>
            </li>
        </ul>
    </div>
</div>
<!-- Menu -->
<div
    class="header-navbar navbar-expand-sm navbar navbar-horizontal navbar-static navbar-light navbar-shadow menu-border d-flex justify-content-center">
    <div class="navbar-container main-menu-content">
        <ul class="nav navbar-nav" id="main-menu-navigation">
            <li class="nav-item" [class.active]="router.url == '/'">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/']">
                    <i class="feather icon-home"></i>
                    <span>Dashboard</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="currentUser.role.title == 'Admin'"
                [class.active]="router.url.includes('users') && !router.url.includes('settings')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/users']">
                    <i class="feather icon-users"></i><span>Users</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('courses')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/courses']">
                    <i class="feather icon-book-open"></i>
                    <span>Courses</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('tasks')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/tasks']">
                    <i class="feather icon-file-text"></i>
                    <span>Assignments</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('file-manager')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/file-manager']">
                    <i class="feather icon-folder"></i>
                    <span>File Manager</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('announcements')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/announcements']">
                    <i class="feather icon-radio"></i>
                    <span>Announcements</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('appointments')">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/appointments']">
                    <i class="feather icon-users"></i>
                    <span>Appointments</span>
                </a>
            </li>
            <li class="nav-item" [class.active]="router.url.includes('requests/registrations')"
                *ngIf="currentUser.role.title == 'Admin'">
                <a class="nav-link" href="javascript:void(0)" [routerLink]="['/requests/registrations']">
                    <i class="feather icon-users"></i>
                    <span>New Registrations</span>
                </a>
            </li>
            <!-- <li class="dropdown nav-item" *ngIf="currentUser.role.title == 'Admin'"
            [class.active]="router.url.includes('requests')">
                <a class="dropdown-toggle nav-link" href="javascript:void(0)" data-toggle="dropdown">
                    <i class="feather icon-grid"></i><span>New Requests</span>
                </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="javascript:void(0)" data-toggle="dropdown"
                            [routerLink]="['/requests/enrollments']">Enrollments</a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" data-toggle="dropdown"
                            [routerLink]="['/requests/registrations']">Registrations</a></li>
                </ul>
            </li> -->
        </ul>
    </div>
</div>
